;(function () {
  'use strict';

  var imageSelector = {
    config: {
      className: '.js-image-selector',
      labelClassName: '.js-image-selector-label',
      dataSelectType: 'select-type',
      selectTypeSingle: 'single',
      selectTypeMulti: 'multi',
    },
    $selector: null,
    selectType: null,

    /**
     * 初期化
     */
    init: function () {
      var config = this.config;
      this.$selector = $(config.className);
      if (!this.$selector) {
        return false;
      }

      this.selectType = this.$selector.data(config.dataSelectType);
      if (this.selectType === config.selectTypeSingle) {
        this.singleSelector();
      } else if (this.selectType === config.selectTypeMulti) {
        this.multiSelector();
      }

      this.resetSelection();
    },

    /**
     * 選択 [radio]
     */
    singleSelector: function () {
      var self = this;
      var config = this.config;
      this.$selector.find(config.labelClassName).on('change', 'input', function () {
        self.resetSelection();
      });
    },

    /**
     * 複数選択 [checkbox]
     */
    multiSelector: function () {
      var self = this;
      var config = this.config;
      this.$selector.find(config.labelClassName).on('change', 'input', function () {
        self.toggleSelection($(this));
      });
    },

    /**
     * チェック切り替え
     */
    resetSelection: function () {
      var config = this.config;
      this.$selector.find(config.labelClassName).each(function () {
        var $label = $(this);
        var $input = $label.find('input');
        if ($input.prop('checked')) {
          $label.addClass('checked');
        } else {
          $label.removeClass('checked');
        }
      });
    },

    /**
     * チェック切り替え
     *
     * @param $input  {jQuery}  チェックボックス／ラジオボタン
     */
    toggleSelection: function ($input) {
      var selected = $input.prop('checked');
      var $label = $input.closest('label');
      if (selected) {
        $label.addClass('checked');
      } else {
        $label.removeClass('checked');
      }
    },
  };

  /**
   * DOM content loaded
   */
  $(function () {
    imageSelector.init();
  });

}.call(this));
